import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../components/LanguageContext';
import client from '../../sanity/client';
import { Link } from 'react-router-dom';
import { PlusIcon, ArrowRight } from '../../assets/svg';
import './ExpositionsStyles.scss';

const Expositions = () => {
  const [data, setData] = useState(null);
  const { language } = useLanguage();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const query = `*[_type == "expositions"][0]{
          title,
          expositions[]{
            _key,
            title,
            "slug": slug.current
          }
        }`;
        const result = await client.fetch(query);
        setData(result);
      } catch (error) {
        console.error('Erreur lors de la récupération des expositions:', error);
      }
    };

    fetchData();
  }, []);

  const getSafeTitle = (titleObj) => {
    if (!titleObj) return 'Titre par défaut';
    if (typeof titleObj === 'string') return titleObj;
    return titleObj[language] || titleObj.fr || titleObj.en || 'Titre';
  };

  if (!data) return <div>Loading...</div>;

  return (
    <div className="oeuvre-page">
      <h1 data-aos="fade-zoom-in"
     data-aos-easing="ease-in-back"
     data-aos-delay="300"
     data-aos-offset="0">
        {data.title?.[language] || data.title?.fr || data.title?.en || 'Expositions'}
      </h1>
      
      <div className="works-list">
        {data.expositions?.map((expo, index) => (
          <div 
            key={expo._key} 
            className="work-item"
            data-aos="fade-in"
            data-aos-duration="600"
            data-aos-delay={index * 150}
          >
            <Link to={`/chemin/expositions/${expo.slug}`} className="work-header hover-icon-transition">
              <h2>{getSafeTitle(expo.title)}</h2>
              <span className="icon-wrapper">
                <span className="plus-icon"><PlusIcon /></span>
                <span className="arrow-icon"><ArrowRight /></span>
              </span>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Expositions;